@let memberValue = member();

<div class="member">
  <div class="member-details">
    <rt-avatar
      [type]="!!memberValue.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="memberValue.avatarThumbUrl"
      [fullName]="memberFullName()"
      context="admin"
    />
    <div class="member-name">
      <div class="name-wrapper">
        <rt-heading>
          <rt-truncate>{{ memberFullName() }}</rt-truncate>
        </rt-heading>
      </div>
      @if (memberValue.hasWorkEmail && memberValue.email) {
        <span class="email"
          ><rt-truncate>{{ memberValue.email }}</rt-truncate></span
        >
      } @else if (!memberValue.hasWorkEmail && memberValue.login) {
        <span class="email"
          ><rt-truncate>{{ memberValue.login }}</rt-truncate></span
        >
      }
    </div>
  </div>
  <div class="buttons-container">
    <rt-button variant="plain" (click)="viewMember.emit(memberValue.guid)">
      <rt-icon name="open-in-new" />
      <span>{{ 'tlc.common.view' | translate }}</span>
    </rt-button>
    @if (canUnassign()) {
      <rt-button variant="plain" (click)="unassignMember.emit(memberValue)">
        <rt-icon name="close" />
        <span>{{ 'tlc.common.remove' | translate }}</span>
      </rt-button>
    }
  </div>
</div>
